import type { SetupContext } from 'vue'

import { QuestionCircleOutlined } from '@ant-design/icons-vue'
import { Tooltip } from 'ant-design-vue'

export const Helper = (props: { title?: string }, { slots }: SetupContext) => {
  return (
    <div class="flex items-center justify-center">
      {slots.default?.()}
      <Tooltip title={props.title}>
        <QuestionCircleOutlined class="ml-1 cursor-pointer" />
      </Tooltip>
    </div>
  )
}

Helper.props = {
  title: {
    type: String,
    default: '',
  },
}
